export type TIcon = typeof allIcons[number];
export const allIcons = ['Bars', 'Times', 'Download', 'ExternalLink', 'Copy'] as const;